import { TreeViewNode } from "../components/TreeView/treeViewNode";
export class ParameterData {
    constructor() {
        //All concepts
        this.id = "";
        this.name = "";
        this.type = "";
        this.description = "";
        this._treeViewNode = null;
    }
    deserialize(input) {
        this.id = input.id;
        this.name = input.name;
        this.type = input.type;
        this.description = input.description;
        return this;
    }
    getTreeViewNode() {
        if (!this._treeViewNode) {
            const children = new Array();
            this._treeViewNode = new TreeViewNode(this.name /*+ ":" + this.type*/, this.description, children);
        }
        return this._treeViewNode;
    }
}
